<template>
  <th :colspan="colspan" class="pg-table-header">
    <div @click="$refs.modal.show()" :class="{ 'pg-header-label': true, 'active': active }">
      {{ title }}
    </div>
    <div :class="{ 'pg-header-widget': true, 'active': active }">
      {{ selected[this.label] }}
      <i @click="cancel" class="pg-close"></i>
    </div>
    <pg-modal :title="title"
            subtitle='<span class="bold">Select</span> is used for filtering by specified value' 
                ref="modal">    
      <div slot="body">
        <form class="form-horizontal" role="form" autocomplete="off">
          <div class="form-group">
            <label for="fname" class="col-sm-3 control-label">SELECT</label>
            <pg-container sm="9">
              <pg-multiselect
                v-model="selected"
                :options="items"
                :track-by="id"
                :label="label"
                @input="setValue"
                @search-change="fetch"></pg-multiselect>
            </pg-container>
          </div>
        </form>
      </div>
      <div slot="footer" class="m-t-5">
        <pg-container sm="4"></pg-container>
        <pg-container sm="4">
          <pg-button @click.native="$refs.modal.hide()" type="default" block>Cancel</pg-button>
        </pg-container>
        <pg-container sm="4">
          <pg-button @click.native="save" type="complete" block>Filter</pg-button>
        </pg-container>
      </div>
    </pg-modal>
  </th>
</template>

<script>
  export default {
    name: 'TableHeader',
    props: {
      title: {
        type: String,
        default: ''
      },
      colspan: {
        type: Number,
        default: 1
      },
      url: {
        type: String,
        default: ''
      },
      onChange: {
        type: Function,
        default: (key, value) => {}
      },
      label: {
        type: String,
        default: 'name'
      },
      id: {
        type: String,
        default: 'id'
      },
      filter: {
        type: String,
        default: 'default_key'
      }
    },
    data: () => ({
      active: false,
      items: [],
      selected: {}
    }),
    created() {
      this.fetch();
    },
    methods: {
      fetch() {
        this.$http
          .get(this.url, { params: this.$params })
          .then((response) => {
            this.items = response.data;
          });
      },
      save() {
        this.active = true;
        this.$refs.modal.hide();
        this.onChange(this.filter, this.selected[this.id]);
        this.$emit('filter_change', { key: this.filter, value: this.selected[this.id] });
      },
      setValue(value) {
        this.selected = value;        
      },
      cancel(value) {        
        this.active = false;
        this.onChange(this.filter, null);
        this.$emit('filter_change', { key: this.filter, value: null });
      }
    }
  }
</script>

<style lang="sass">
  .pg-table-header {
    display: table-cell;
    font-family: 'Montserrat';

    .pg-header-label {
      color: #08c;
      transition: all 0.3s ease;
      cursor: pointer;
      font-family: 'Montserrat';
    }

    .pg-header-label.active {
    }

    .pg-header-widget {
      display: none;
      font-family: 'Montserrat';
      color: #F55753;

      small {
        
      }
    }

    .pg-header-widget.active {
      display: block;
    }

    .pg-header-widget.active i {
      font-size: 18px;
      cursor: pointer;
    }

    .pg-header-widget.active i:hover {
      color: black;
    }
  }  
</style>


// WEBPACK FOOTER //
// table_header.vue?befae1c2